import React, {useState, useEffect} from 'react';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, Stack, Button, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link, useParams, useLocation } from "react-router-dom";
import ApproveTable from '../components/approve_topic/ApproveTable'
import NoPermission from './NoPermission';
import * as CONSTANTS from "../constants"

import { view_wotageishi_request } from '../services/topic_request';

const WotageishiApprove = () => {

    document.title = `Approve Wotageishis - Wotagei Zone`

    const location = useLocation();
    let {lang} = useParams();

    // hook
    const [maxPage, setMaxPage] = useState(1);
    const [wotageishis, setWotageishis] = useState([]);
    const [hasPermission, setHasPermission] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [drawerOpen, setDrawerOpen] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // fetch data
    const fetchWotageishiRequests = async (page) => {
        const [status, result] = await view_wotageishi_request(lang, page)
        if (status === 200) {
            setWotageishis(result.requests);
            setMaxPage(Math.ceil(result.records_count / 10))
            setHasPermission(true);
        }
        setIsLoading(false);
    }

    useEffect(()=>{
        fetchWotageishiRequests(1);
    }, [location.pathname])

    return (
        isLoading?
        <></>
        :
        (
            hasPermission?
            <Box >
                <CssBaseline />
                <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
                <Box sx={{ display: 'flex' }}>
                    <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                    <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3, overflowY: "hidden" }}>
                        <Toolbar />
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={12}>
                                <Typography 
                                    xs={12}
                                    variant="h5" 
                                    style={{
                                        textAlign: "left",
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.DRAWER.APPROVE_TOPIC[lang].toUpperCase()}
                                </Typography>

                                <Box pt={3} pb={3} xs={12} md={12} height={'100%'} sx={{width: '100%'}}>
                                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                                        <Link style={{ flex: 1, textDecoration: 'none' }} to={`/${lang}/approve-topic/`}>
                                            <Button variant="outlined" fullWidth >
                                                {CONSTANTS.APPROVE_TOPIC.DASHBOARD[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none' }} to={`/${lang}/approve-topic/wazaren/`}>
                                            <Button variant="outlined" fullWidth>
                                                {CONSTANTS.DRAWER.WAZAREN[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none' }}>
                                            <Button variant="outlined" fullWidth disabled>
                                                {CONSTANTS.DRAWER.WOTAGEISHI[lang]}
                                            </Button>
                                        </Link>
                                        <Link style={{ flex: 1, textDecoration: 'none' }} to={`/${lang}/approve-topic/organization/`}>
                                            <Button variant="outlined" fullWidth>
                                                {CONSTANTS.DRAWER.ORGANIZATION[lang]}
                                            </Button>
                                        </Link>
                                    </Stack>

                                </Box>
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ApproveTable lang={lang} datas={wotageishis} refreshDatas={fetchWotageishiRequests} maxPage={maxPage}/>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            :
            <NoPermission />
        )
    );
};
 
export default WotageishiApprove;